import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Mail } from 'lucide-react';

export default function Footer() {
  const handleEmailClick = async (e) => {
    e.preventDefault();
    const email = 'contact@symetrixconsulting.com';

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(email);
      }
    } catch (err) {
      // Silently fail if clipboard is not available
    }

    window.location.href = `mailto:${email}`;
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-8" data-anim="list-stagger" data-stagger="100">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="bg-blue-600 text-white font-bold px-3 py-1.5 text-lg inline-block mb-4">
              Symetrix
            </div>
            <p className="text-sm text-gray-400 mb-4 max-w-sm">
              Connecting visionary organizations with exceptional talent through strategic precision and human insight.
            </p>
            <div className="flex space-x-4">
              <button
                onClick={handleEmailClick}
                className="text-gray-400 hover:text-white transition-colors"
                data-testid="footer-email-link"
                aria-label="Email Symetrix HR Consulting"
                type="button"
              >
                <Mail size={20} />
              </button>
              <a 
                href="https://www.facebook.com/symetrixhrconsulting" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-white transition-colors" 
                data-testid="social-facebook"
                aria-label="Visit our Facebook page"
              >
                <Facebook size={20} />
              </a>
              <a 
                href="https://twitter.com/symetrixconsult" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-white transition-colors" 
                data-testid="social-twitter"
                aria-label="Visit our Twitter page"
              >
                <Twitter size={20} />
              </a>
              <a 
                href="https://www.linkedin.com/company/symetrix-hr-consulting" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-white transition-colors" 
                data-testid="social-linkedin"
                aria-label="Visit our LinkedIn page"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>
          
          {/* Company */}
          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/careers" className="hover:text-white transition-colors">Careers</Link></li>
              <li><Link to="/leadership" className="hover:text-white transition-colors">Our Team</Link></li>
              <li><Link to="/leadership" className="hover:text-white transition-colors">Partnerships</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>
          
          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/services" className="hover:text-white transition-colors">Executive Search</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">Consulting</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">Staffing</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">Recruitment</Link></li>
            </ul>
          </div>
          
          {/* Resources */}
          <div>
            <h3 className="text-white font-semibold mb-4">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/blog" className="hover:text-white transition-colors">Blog</Link></li>
              <li><Link to="/careers" className="hover:text-white transition-colors">Job Openings</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors">Case Studies</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Support</Link></li>
            </ul>
          </div>
        </div>
        
        {/* Bottom */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-400">
            &copy; {new Date().getFullYear()} Symetrix. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors">Terms of Service</a>
            <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
